/**
 * Copyright Mántum All Rights Reserved.
 */
import { useCallback, useState } from 'react';

export default (defaultValue = false) => {
    const [value, setValue] = useState<boolean>(defaultValue);

    const onOpen = useCallback(() => {
        setValue(true);
    }, []);

    const onClose = useCallback(() => {
        setValue(false);
    }, []);

    const onToggle = useCallback(() => {
        setValue((previous) => !previous);
    }, []);

    return {
        value,
        onOpen,
        onClose,
        onToggle
    };
};
